export const notFoundError = (message: string) => {
  const error: any = Error(message)
  error.status = 404
  throw error
}
